import Vue from 'vue'
import VueRouter from 'vue-router'

// 启用 Vue Router
Vue.use(VueRouter)

// 定义路由配置
const routes = [
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error/404.vue') // 懒加载
    },
    {
        path: '/orderShow',
        name: 'OrderShow',
        component: () => import('@/views/wechatPayLink/orderShow.vue')
    },
]

// 创建 router 实例
const router = new VueRouter({
    mode: 'history', // 使用 HTML5 History 模式
    routes
})

export default router
